import { Outlet } from 'react-router';
import { SkipLink } from '@ircf/ui';
import { PublicHeader } from '../components/public/PublicHeader.js';
import { PublicFooter } from '../components/public/PublicFooter.js';

export function AuthLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-near-black">
      <SkipLink href="#main">Skip to main content</SkipLink>
      <PublicHeader />
      <main
        id="main"
        tabIndex={-1}
        className="relative z-10 flex flex-1 items-start justify-center px-4 pt-28 pb-16 focus-visible:outline-none sm:pt-36 sm:pb-20"
      >
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
